import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { forwardRef, useRef, useState } from "react";
import { useDirection } from "./auth-service-tools250.js";
import { useScrollAreaContext } from "./auth-service-tools543.js";
import { getThumbRatio } from "./auth-service-tools1006.js";
import { getThumbOffsetFromScroll } from "./auth-service-tools1007.js";
import { getScrollPositionFromPointer } from "./auth-service-tools1008.js";
import { ScrollAreaScrollbarX } from "./auth-service-tools1009.js";
import { ScrollAreaScrollbarY } from "./auth-service-tools1010.js";
const ScrollAreaScrollbarVisible = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    orientation = "vertical",
    ...scrollbarProps
  } = props;
  const {
    dir
  } = useDirection();
  const context = useScrollAreaContext();
  const thumbRef = useRef(null);
  const pointerOffsetRef = useRef(0);
  const [sizes, setSizes] = useState({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  });
  const thumbRatio = getThumbRatio(sizes.viewport, sizes.content);
  const commonProps = { ...scrollbarProps,
    sizes,
    onSizesChange: setSizes,
    hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
    onThumbChange: thumb => {
      thumbRef.current = thumb;
    },
    onThumbPointerUp: () => {
      pointerOffsetRef.current = 0;
    },
    onThumbPointerDown: pointerPos => {
      pointerOffsetRef.current = pointerPos;
    }
  };

  const getScrollPosition = (pointerPos, direction) => getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, direction);

  if (orientation === "horizontal") {
    return /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarX, { ...commonProps,
      ref: forwardedRef,
      onThumbPositionChange: () => {
        if (context.viewport && thumbRef.current) {
          const scrollPos = context.viewport.scrollLeft;
          const offset = getThumbOffsetFromScroll(scrollPos, sizes, dir);
          thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
        }
      },
      onWheelScroll: scrollPos => {
        if (context.viewport) {
          context.viewport.scrollLeft = scrollPos;
        }
      },
      onDragScroll: pointerPos => {
        if (context.viewport) {
          context.viewport.scrollLeft = getScrollPosition(pointerPos, dir);
        }
      }
    });
  }

  if (orientation === "vertical") {
    return /* @__PURE__ */jsxRuntimeExports.jsx(ScrollAreaScrollbarY, { ...commonProps,
      ref: forwardedRef,
      onThumbPositionChange: () => {
        if (context.viewport && thumbRef.current) {
          const scrollPos = context.viewport.scrollTop;
          const offset = getThumbOffsetFromScroll(scrollPos, sizes);

          if (sizes.scrollbar.size === 0) {
            thumbRef.current.style.opacity = "0";
          } else {
            thumbRef.current.style.opacity = "1";
          }

          thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
        }
      },
      onWheelScroll: scrollPos => {
        if (context.viewport) {
          context.viewport.scrollTop = scrollPos;
        }
      },
      onDragScroll: pointerPos => {
        if (context.viewport) {
          context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
      }
    });
  }

  return null;
});
ScrollAreaScrollbarVisible.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
export { ScrollAreaScrollbarVisible };